import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatashareService {
  isSidebarOpen: Subject<boolean> = new Subject<boolean>();
  isMiniSidebar: Subject<boolean> = new Subject<boolean>();
  $updateFolderFiles: Subject<boolean> = new Subject<boolean>();
  $resetMultiSelection: Subject<boolean> = new Subject<boolean>();
  $resetSidebarSelectionOnBreadcrumbsLink: Subject<any> = new Subject<any>();
  $updateFolderInformation: Subject<any> = new Subject<any>();
  $updateRecentFolders: Subject<boolean> = new Subject<boolean>();
  $updateStarredFolders: Subject<boolean> = new Subject<boolean>();
  $openFilePreviewModal: Subject<any> = new Subject<any>();
  $searchShareData: Subject<any> = new Subject<any>();
  $updateSidebarOnSearchSelection: Subject<string> = new Subject<string>();
  folderId: string = '';

  ids: any[] = [];
  private _isSidebarOpen = false;
  private _isMiniSidebar = false;

  constructor() {}
  toggleSidebar(): void {
    this._isSidebarOpen = !this._isSidebarOpen;
    this.isSidebarOpen.next(this._isSidebarOpen);
  }
  toggleMiniSidebar(): void {
    this._isMiniSidebar = !this._isMiniSidebar;
    this.isMiniSidebar.next(this._isMiniSidebar);
  }

  updateFolderFiles(updateTree: any): void {
    this.$updateFolderFiles.next(updateTree);
  }

  resetMultiSelection(check: boolean): void {
    this.$resetMultiSelection.next(check);
  }

  resetSidebarSelectionOnBreadcrumbsLink(check: any): void {
    this.$resetSidebarSelectionOnBreadcrumbsLink.next(check);
  }

  updateFolderInformation(files: any): void {
    this.$updateFolderInformation.next(files);
  }

  searchShareData(data: any): void {
    this.$searchShareData.next(data);
  }

  updateRecentFolders(isUpdate: boolean): void {
    this.$updateRecentFolders.next(isUpdate);
  }

  updateStarredFolders(isUpdate: boolean): void {
    this.$updateStarredFolders.next(isUpdate);
  }

  openFilePreviewModal(file: any): void {
    this.$openFilePreviewModal.next(file);
  }

  updateSidebarOnSearchSelection(data: string): void {
    this.$updateSidebarOnSearchSelection.next(data);
  }

  setFolderId(folderId: string): void {
    this.folderId = folderId;
  }

  getFolderId(): any {
    return this.folderId === '' ? null : this.folderId;
  }

  resetCheckedIds(): void {
    this.ids = [];
  }

  setCheckedIds(folderId: string): void {
    if (!this.ids.includes(folderId)) {
      this.ids.push(folderId);
    }
  }

  removedUncheckedIds(folderId: string): void {
    const index = this.ids.indexOf(folderId, 0);
    if (index > -1) {
      this.ids.splice(index, 1);
    }
  }

  getCheckedIds(): any {
    return this.ids;
  }
}
